<template>
  <layout-pondlogs headerType="none" class="settings-tab-component">
    <template slot="pondlogs-default-layout-main">
      <er-tabs
        :value="computedComponentName"
        class="settings-tab"
        @tab-click="handleSettingsTabClick"
      >
        <el-tab-pane :name="components['feed'].name">
          <span slot="label">{{ components["feed"].label }}</span>
        </el-tab-pane>

        <el-tab-pane :name="components['medicine'].name">
          <span slot="label">{{ components["medicine"].label }}</span>
        </el-tab-pane>
        <component
          :is="computedComponentName"
          @change-tab="handleChangeTabTo"
        ></component>
      </er-tabs>
    </template>
  </layout-pondlogs>
</template>

<script>
import feed from "@/views/stock/feed";
import medicine from "@/views/stock/medicine";

export default {
  components: {
    feed,
    medicine
  },

  data() {
    return {
      activeName: "first"
    };
  },
  created() {
    for (const key in this.storeModules) {
      if (!this.$store.hasModule(key)) {
        this.$store.registerModule(key, this.storeModules[key]);
      }
    }
    if (this.$route.query.tab === undefined) {
      this.$router.push({
        path: "/user/stock",
        query: { tab: "feed" }
      });
    }
  },
  beforeRouteLeave(to, from, next) {
    for (const key in this.storeModules) {
      if (this.$store.hasModule(key)) {
        this.$store.unregisterModule(key);
      }
    }
    next();
  },

  computed: {
    computedComponentName: function() {
      return this.$route.query.tab;
    },
    components() {
      return {
        feed: { name: "feed", label: this.$t("Comn_feed") },
        medicine: { name: "medicine", label: this.$t("Comn_medicines") }
      };
    }
  },
  methods: {
    handleSettingsTabClick(tab) {
      this.$router.push({
        path: "/user/stock",
        query: { tab: tab.paneName }
      });
    },
    handleChangeTabTo: function(tabComponentName) {
      this.$router.replace({
        path: "/user/settings",
        query: { tab: tabComponentName }
      });
    }
  }
};
</script>

<style lang="scss">
.er-tabs .el-tabs__content {
  padding: 12px;
  background: white;
}
</style>
